import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { icons } from '../../Icons.js';
import styles from './Preloader.css?raw';

export class Preloader extends LitElement {
  static styles = [
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    visible: { type: Boolean, reflect: true },
    type: { type: String, reflect: true },
  };
  constructor() {
    super();
    this.visible = true;
    this.type = 'logo';
  }
  _renderLogo() {
    return html`<div class="preloader-logo">${unsafeHTML(icons.R)}</div>`;
  }
  render() {
    //if (!this.visible) return html``;
    // if (this.type.trim().toLowerCase() === 'logo') {
    return html`${this._renderLogo()}`;
    // }
    //  return html``;
  }
}
if (!customElements.get('rd-preloader')) customElements.define('rd-preloader', Preloader);
